import { AvailableTime, AvailableTimeByDay } from "./type";

export const formatDate = (dateString?: string | null): string => {
    if (!dateString) return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Tháng từ 0-11
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
};


export const formatBytes = (bytes: number | null, decimals = 2): string => {
    if (bytes === null) return 'N/A';
    if (bytes === 0) return '0 B';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function timeAgo(dateString: string) {
    const date = new Date(dateString);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 60) return "Just now";

    const minutes = Math.floor(seconds / 60);
    if (minutes < 60) return `${minutes} minute${minutes > 1 ? "s" : ""} ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours} hour${hours > 1 ? "s" : ""} ago`;

    const days = Math.floor(hours / 24);
    if (days < 30) return `${days} day${days > 1 ? "s" : ""} ago`;

    const months = Math.floor(days / 30);
    if (months < 12) return `${months} month${months > 1 ? "s" : ""} ago`;

    const years = Math.floor(months / 12);
    return `${years} year${years > 1 ? "s" : ""} ago`;
}

export const formatHourAndDate = (isoString: any) => {
    const date = new Date(isoString);

    const hh = String(date.getHours()).padStart(2, "0");
    const mm = String(date.getMinutes()).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const MM = String(date.getMonth() + 1).padStart(2, "0");
    const yyyy = date.getFullYear();

    return `${hh}h:${mm}m  ${dd}/${MM}/${yyyy}`;
};

export const formatAvailableTime = (
    data: AvailableTime[]
): AvailableTimeByDay => {
    const result: AvailableTimeByDay = {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
    };

    data.forEach((item) => {
        const day = item.dayOfWeek as keyof AvailableTimeByDay;
        result[day]?.push(item);
    });

    return result;
};

export const getFileIcon = (fileName: string, changeSize?: boolean) => {
    const fileType = fileName.toLowerCase();

    if (fileType.includes("pdf")) {
        return <i className={`fa-solid fa-file-pdf ${changeSize ? "text-[30px]" : "text-[20px]"} text-red-500`}></i>;
    }
    if (fileType.includes("doc") || fileType.includes("docx") || fileType.includes("word")) {
        return <i className={`fa-solid fa-file-word ${changeSize ? "text-[30px]" : "text-[20px]"} text-blue-500`}></i>;
    }
    if (fileType.includes("xls") || fileType.includes("xlsx") || fileType.includes("excel")) {
        return <i className={`fa-solid fa-file-excel ${changeSize ? "text-[30px]" : "text-[20px]"} text-green-500`}></i>;
    }
    if (fileType.includes("ppt") || fileType.includes("pptx") || fileType.includes("powerpoint")) {
        return <i className={`fa-solid fa-file-powerpoint ${changeSize ? "text-[30px]" : "text-[20px]"} text-orange-500`}></i>;
    }
    if (fileType.includes("zip") || fileType.includes("rar")) {
        return <i className={`fa-solid fa-file-zipper ${changeSize ? "text-[30px]" : "text-[20px]"} text-yellow-500`}></i>;
    }
    if (fileType.includes("png") || fileType.includes("jpg") || fileType.includes("jpeg") || fileType.includes("gif")) {
        return <i className={`fa-solid fa-image ${changeSize ? "text-[30px]" : "text-[20px]"} text-purple-500`}></i>;
    }

    return <i className={`fa-solid fa-file ${changeSize ? "text-[30px]" : "text-[20px]"} text-gray-500`}></i>;
};

export const isImageFile = (url?: string) => {
    if (!url) return false;
    return /\.(jpg|jpeg|png|gif|webp)$/i.test(url);
};

// export const getAvatarText = (fullName: string) => {
//     return fullName
//         .split(" ")
//         .map(namePart => namePart.charAt(0).toUpperCase())
//         .join("");
// }

export const getAvatarText = (fullName: string) => {
    const parts = fullName.trim().split(" ");
    return parts[parts.length - 1].charAt(0).toUpperCase();
};

export const formatData = (data: any) => {
    return data?.map((item: any) => ({
        value: item.code,
        label: item.name ?? item.title,
        address: item.address,
    })) || [];
}

